// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { BarChart } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconBarChart(props: any) {
    return <IconBase icon={BarChart} {...props} />
  }

  export default IconBarChart
  